module.exports = __webpack_public_path__ + "img/huobao.02333a7d.png";